<header >
    <div class="container header-main" >
        <a href="/" class="header-logo">
            <img src="/images/logo.png" alt="logo" />
        </a>
        <div>
            <ul>
                <li>
                    <a [routerLink]="['/convert']" routerLinkActive="is-active-1" href="/convert">Convert</a>
                </li>
                <li>
                    <a [routerLink]="['/merge']" routerLinkActive="is-active-2" href="/merge">Merge</a>
                </li>
                <li>
                    <a [routerLink]="['/compress']" routerLinkActive="is-active-3" href="/compress">Compress</a>
                </li>
            </ul>
        </div>
      
    </div>
</header>